var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Telephone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.8c1.5 4.4 3.4 7.5 7.8 9.8l2.2-2.6 4.1 2.7-1.9 4.7c-.4 1-1.5 1.5-2.5 1.2C9.6 17.7 5 13.1 3.1 6.7c-.3-1 .2-2.1 1.2-2.5l2.1-.4Z",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterPhone);
export default __webpack_public_path__ + "static/media/andus-footer-phone.964e7661b249e6c80ec71d320df5cbfe.svg";
export { ForwardRef as ReactComponent };